var _rect, _rect2, _rect3, _rect4, _path, _path2, _rect5, _rect6, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _rect7, _path7, _path8, _rect8, _rect9, _path9, _path10, _path11, _path12, _circle12, _circle13, _circle14, _circle15, _circle16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrincipleOfSpectrophotometryPoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 150,
    viewBox: "0 0 241 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 237,
    height: 146,
    rx: 3,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 237,
    height: 146,
    rx: 3,
    stroke: "#668BA6",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 4,
    width: 1,
    height: 143,
    fill: "#668BA6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 115,
    height: 140,
    fill: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9737 24.6836H73.0263V119.949C73.0263 124.396 69.4917 128 65.1316 128H59.8684C55.5083 128 51.9737 124.396 51.9737 119.949V24.6836Z",
    fill: "#99B2C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2895 24.6836H71.7105V118.608C71.7105 122.313 68.765 125.316 65.1316 125.316H59.8684C56.235 125.316 53.2895 122.313 53.2895 118.608V24.6836Z",
    fill: "#ECF1F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 22,
    width: 25,
    height: 2.68354,
    rx: 1.34177,
    fill: "#99B2C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 68.4211,
    y: 22,
    width: 6.57895,
    height: 2.68354,
    rx: 1.34177,
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2895 34.0762H71.7105V118.608C71.7105 122.313 68.765 125.317 65.1316 125.317H59.8684C56.235 125.317 53.2895 122.313 53.2895 118.608V34.0762Z",
    fill: "#99DFF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.2149 121.932C53.0812 125.42 56.1793 128 59.8684 128H65.1315C69.4917 128 73.0263 124.396 73.0263 119.949V24.6836H69.7368V113.911C69.7368 119.84 65.024 124.646 59.2105 124.646C56.5251 124.646 54.0746 123.62 52.2149 121.932Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 99L47 75L30.5 51V59.0441H13V90.9558H30.5V99Z",
    fill: "#EFDD35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5 82L112 75L95.5 68V70.3462H78V79.6538H95.5V82Z",
    fill: "#EFDD35"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 44.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 55.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 64.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 73.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 81.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 93.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 84.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 105.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 117.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 105.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 40.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 5,
    width: 115,
    height: 140,
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.974 24.6836H189.026V119.949C189.026 124.396 185.492 128 181.132 128H175.868C171.508 128 167.974 124.396 167.974 119.949V24.6836Z",
    fill: "#99B2C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.289 24.6836H187.711V118.608C187.711 122.313 184.765 125.316 181.132 125.316H175.868C172.235 125.316 169.289 122.313 169.289 118.608V24.6836Z",
    fill: "#ECF1F2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 22,
    width: 25,
    height: 2.68354,
    rx: 1.34177,
    fill: "#99B2C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 184.421,
    y: 22,
    width: 6.57895,
    height: 2.68354,
    rx: 1.34177,
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M169.289 34.0762H187.711V118.608C187.711 122.313 184.765 125.317 181.132 125.317H175.868C172.235 125.317 169.289 122.313 169.289 118.608V34.0762Z",
    fill: "#99DFF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.215 121.932C169.081 125.42 172.179 128 175.868 128H181.132C185.492 128 189.026 124.396 189.026 119.949V24.6836H185.737V113.911C185.737 119.84 181.024 124.646 175.21 124.646C172.525 124.646 170.075 123.62 168.215 121.932Z",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.5 99L163 75L146.5 51V59.0441H129V90.9558H146.5V99Z",
    fill: "#EFDD35"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.5 89L228 75L211.5 61V65.6923H194V84.3075H211.5V89Z",
    fill: "#EFDD35"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 61.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.5,
    cy: 81.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.5,
    cy: 100.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.5,
    cy: 117.5,
    r: 3.5,
    fill: "#DD7E6B"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.5,
    cy: 40.5,
    r: 3.5,
    fill: "#DD7E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincipleOfSpectrophotometryPoster);
export default __webpack_public_path__ + "static/media/principle-of-spectrophotometry-poster.3dc0a40a0eaa7dfda3c947934a78f014.svg";
export { ForwardRef as ReactComponent };